export default __webpack_public_path__ + "static/media/1.1ed0ac24.gif";